exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sort-control[data-v-c8cdd2b4] {\n  margin-bottom: 0;\n}\n.sort-control select[data-v-c8cdd2b4] {\n  margin-bottom: 10px;\n}\n@media only screen and (min-width: 768px) {\n.sort-control select[data-v-c8cdd2b4]:nth-child(2) {\n    width: 20%;\n}\n}\n@media only screen and (min-width: 768px) {\n.sort-control select[data-v-c8cdd2b4]:nth-child(3) {\n    width: 20%;\n}\n}\n\n", ""]);

// exports
